export class RoutePaths {
	static createCodeSnippetRoute = () => {
		return "/snippets/new";
	};

	static codeSnippetDetailRoute = (snippetId: string) => {
		return `/${snippetId}`;
	};
	static codeSnippetDetailWithRevisionRoute = (
		snippetId: string,
		revision: number
	) => {
		return `/${snippetId}/${revision}`;
	};

	static codeSnippetListRoute = () => {
		return `/snippets`;
	};
	static loginRoute = () => {
		return `/login`;
	};
	static landing = () => {
		return `/`;
	};
}
export class AppRoutePathsFormat {
	static createCodeSnippetRoute = () => {
		return "/snippets/new";
	};

	static codeSnippetDetailRoute = (snippetId: string) => {
		return `/${snippetId}`;
	};
	static codeSnippetDetailWithRevisionRoute = (
		snippetId: string,
		revision: string
	) => {
		return `/${snippetId}/${revision}`;
	};

	static codeSnippetListRoute = () => {
		return `/snippets`;
	};
	static loginRoute = () => {
		return `/login`;
	};
	static landing = () => {
		return `/`;
	};
}
